import store from '@/store/index';

export default {
  show(type, props = {}) {
    store.dispatch('modalsController/SHOW', { type, props });
  },

  close() {
    store.dispatch('modalsController/CLOSE');
  },

  closeAll() {
    store.dispatch('modalsController/CLOSE_ALL');
  },
};
